<div class="rotate-device">
  <div class="phone"></div>
  <div class="message">Fais pivoter ton appareil</div>
  <div class="action">{{ action }}</div>
</div>
